<template>
  <QButtonGroup v-model="activeFilter" :list="activeFilterOptions" :edit="true" dense noempty>
  </QButtonGroup>
</template>


<script>
import FilterQueryMixin from "@/helpers/Mixins/FilterQueryMixin.js";

export default {
  name: "DefaultActiveFilter",
  props: {
    pk: String,
    defaultToActive: {
      type: Boolean,
      default: false,
    },
  },
  components: {},
  mixins: [FilterQueryMixin],

  data() {
    return {
      activeFilterOptions: [
        { value: this.defaultToActive ? 1 : 0, text: this.$t("servicesystem.common_objects.commonterms.any") },
        { value: this.defaultToActive ? 0 : 1, text: this.$t("servicesystem.common_objects.commonterms.active") },
        { value: -1, text: this.$t("servicesystem.common_objects.commonterms.inactive") },
      ],
    };
  },

  mounted() { },

  methods: {},

  computed: {
    activeFilter: {
      get() { return this.getQueryParam("filter-active", 0); },
      set(update) { this.setQueryParam("filter-active", update); },
    },
  },

  watch: {},
};
</script>


<style lang="scss"></style>